import { render, staticRenderFns } from "./TestTable.vue?vue&type=template&id=950261ca&scoped=true&"
import script from "./TestTable.vue?vue&type=script&lang=ts&"
export * from "./TestTable.vue?vue&type=script&lang=ts&"
import style0 from "./TestTable.vue?vue&type=style&index=0&id=950261ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950261ca",
  null
  
)

export default component.exports